angular.module('impactx.toolbar').controller('ToolbarToolsCtrl', [
    'ToolbarService',
    ToolbarToolsController
]);

function ToolbarToolsController(ToolbarService) {
    var self = this;

    self.$onInit = function () {
        self.buttons = ToolbarService.buttons;
        self.scrollMenu = ToolbarService.scrollMenu;
        self.data = ToolbarService.data;
    };

    self.onResize = function () {
        ToolbarService.recalcButtons();
    };
}